<!-- Modal principal -->
<div
*ngIf="abrirModal"
class="fixed inset-0 z-50 flex items-center justify-center bg-gray-800 bg-opacity-50">
<div class="relative p-4 w-full max-w-2xl">
  <div class="relative bg-white rounded-lg shadow dark:bg-gray-800">
    <!-- Encabezado del modal -->
    <div class="flex justify-between items-center p-4 border-b dark:border-gray-600">
      <h3 class="text-lg font-semibold text-gray-900 dark:text-white">
        Código para producto seleccionado
      </h3>
      <button
      (click)="toggleModal()"
        class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg p-1.5 inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white">
        <svg aria-hidden="true" class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path>
        </svg>
      </button>
    </div>

    <form class="p-4" (ngSubmit)="serviceCode()">
      <div class="grid gap-4 sm:grid-cols-1">
        <div>
          <label for="code" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Codigo<span class="text-red-500">*</span></label>
          <input [(ngModel)]="newCode.code" type="text" name="code" id="code" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500" placeholder="Ejem. SC_RCV">
          <span class="text-red-500 text-sm" *ngIf="!newCode.code.trim() && globalError">Código requerido</span>
        </div>

        <div>
          <label for="name" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Nombre<span class="text-red-500">*</span></label>
          <input
          [(ngModel)]="newCode.name"
          type="text"
          name="product"
          id="product"
          class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
          placeholder="Ejem. Seguros Caracas"
          >
          <span class="text-red-500 text-sm" *ngIf="!newCode.name.trim() && globalError">Nombre requerido</span>
        </div>

        <!-- Selector de tipo de producto (solo se muestra cuando no hay producto preseleccionado) -->
        <div *ngIf="!selectedProductCode">
          <label for="products" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Producto<span class="text-red-500">*</span></label>
          <select
          id="products"
          [(ngModel)]="selectedProduct"
          name="products"
          (change)="selectProductInvoice($event)"
          class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
            <option selected value="0">Selecciona un producto</option>
            <option *ngFor="let item of productArray" [value]="item?.params?.code">{{item?.params?.code}}</option>
          </select>
          <span class="text-red-500 text-sm" *ngIf="selectedProduct === '0' && globalError">Producto requerido</span>
        </div>

        <!-- Información del producto seleccionado (cuando hay producto preseleccionado) -->
        <div *ngIf="selectedProductCode" class="bg-blue-50 border border-blue-200 rounded-lg p-4">
          <div class="flex items-center">
            <i class="fas fa-info-circle text-blue-500 mr-3"></i>
            <div>
              <p class="text-sm font-medium text-blue-800">Agregando categoría para:</p>
              <p class="text-sm text-blue-700">
                <strong>{{selectedProductCode}}</strong>
                <span *ngIf="getProductName(selectedProductCode)"> - {{getProductName(selectedProductCode)}}</span>
              </p>
            </div>
          </div>
        </div>

        <div>
          <label for="description" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Descripción<span class="text-red-500">*</span></label>
          <textarea [(ngModel)]="newCode.description" type="text" name="description" id="description" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500 h-44" placeholder="Ejem. Este es un código para multi-productos"></textarea>
        </div>

        <!-- Select de productos de seguros (solo se muestra para productos de seguros) -->
        <div *ngIf="showInsuranceProductSelect" class="bg-blue-50 border border-blue-200 rounded-lg p-4">
          <label for="insuranceProduct" class="block mb-2 text-sm font-medium text-gray-700">
            <i class="fas fa-shield-alt mr-2"></i>Producto de Seguros
          </label>
          <select
            id="insuranceProduct"
            [(ngModel)]="selectedInsuranceProduct"
            name="insuranceProduct"
            [ngModelOptions]="{standalone: true}"
            class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5">
            <option value="">Seleccionar producto de seguros</option>
            <option *ngFor="let product of insurerProducts" [value]="product.code || product.id">
              {{product.name || product.nombre || product.code}}
            </option>
          </select>
          <p class="text-xs text-gray-600 mt-2">
            <i class="fas fa-info-circle mr-1"></i>
            Selecciona el producto de seguro correspondiente a este identificador
          </p>
          <p class="text-xs text-blue-600 mt-1 font-semibold">
            Productos disponibles: {{ insurerProducts.length }}
          </p>
        </div>
      </div>
      <div class="flex items-center space-x-4 mt-4">
        <button type="submit" class="text-white bg-primary-700 hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800 w-[100%]">
          Agregar código
        </button>
      </div>
    </form>
  </div>
</div>
</div>